import React, { ComponentProps } from "react";
import InputShell, { Props as InputShellProps } from "./InputShell";
import clsx from "clsx";
import { HiEye, HiEyeOff } from "react-icons/hi";

type Props = {
  onChange: (newValue: string) => void;
  withShowEye: boolean;
  value: string;
  type?: ComponentProps<"input">["type"];
  autoComplete?: string;
  placeholder?: string;
  className?: string;
} & Omit<InputShellProps, "children">;

function InputPin({
  label,
  onChange,
  error,
  value,
  type = "password",
  withShowEye,
  isOptional,
  autoComplete,
  placeholder,
  className,
  ...rest
}: Props) {
  const [show, setShow] = React.useState(false);
  const inputShell = {
    label,
    error,
    ...(isOptional
      ? { isOptional, optionalLabel: rest.optionalLabel }
      : { required: rest.required })
  };
  return (
    <InputShell {...inputShell}>
      <div className="relative">
        <input
          className={clsx(
            "min-h-[2.5rem] w-full rounded-[0.25rem] border border-outline px-3 text-sm leading-4 tracking-[0.5rem] focus:outline-none",
            className
          )}
          title={label}
          onChange={(e) => {
            const isNum = e.target.value.match(/[0-9]/g);
            if (isNum || e.target.value === "")
              onChange(e.target.value && isNum.join("").substring(0, 6));
          }}
          placeholder={placeholder || "______"}
          type={show ? "text" : type}
          value={value}
          {...(autoComplete && { autoComplete })}
        />
        {withShowEye === true && (
          <div className="absolute inset-y-0 right-0 flex py-1.5 pr-1.5">
            <button
              className="inline-flex items-center rounded px-1 text-gray-400"
              type="button"
              onClick={() => setShow(!show)}
            >
              {!show ? <HiEye /> : <HiEyeOff />}
            </button>
          </div>
        )}
      </div>
    </InputShell>
  );
}

export default InputPin;
